export interface ClearButtonProps {
  handleClick: VoidFunction
  testId?: string
}
